import React, { useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import { FaPlay, FaPause } from "react-icons/fa";

export default function AudioPlayer() {
  const [isPlay, setIsPlay] = useState(false);

  const audioControl = (status) => {
    let x = document.getElementById("backsound");
    if (status) {
      setIsPlay(false);
      x.pause();
    } else {
      setIsPlay(true);
      x.play();
    }
  };

  return (
    <>
      <ReactAudioPlayer
        id="backsound"
        src="/audio/backsound.mp3"
        onPlay={() => audioControl(false)}
        onPause={() => audioControl(true)}
        autoPlay
        loop
      />
      <button
        onClick={() => audioControl(isPlay)}
        className="fixed left-3 bottom-3 w-16 h-16 rounded-full bg-white shadow-xl z-10 flex justify-center items-center text-2xl text-purple"
      >
        {isPlay ? <FaPause /> : <FaPlay />}
      </button>
    </>
  );
}
